export default "__VITE_ASSET__CAqOKk8u__"